import { ListModel } from "@/shared/models/listModel";
import { AccomodationUnitTypeForReportFilter } from "@/shared/models/reportModels";
import Vue from "vue";
import { ActionTree, GetterTree, MutationTree } from "vuex";

const initialState = {
    accomodationUnitTypes: [] as AccomodationUnitTypeForReportFilter[],
};

const state = { ...initialState };

const getters: GetterTree<typeof state, any> = {
    accomodationUnitTypes: (state) => state.accomodationUnitTypes,
};

const actions: ActionTree<typeof state, any> = {
    refreshAccomodationUnitTypes({ commit }) {
      return Vue.axios
        .get<ListModel<AccomodationUnitTypeForReportFilter>>("AccomodationUnitTypes/GetForReportsFilter")
        .then((res) => {
          commit("setAccomodationUnitTypes", res.data.result);
        });
    },
};

const mutations: MutationTree<typeof state> = {
  reset: (state) => {
    Object.assign(state, initialState);
  },
  setAccomodationUnitTypes: (state, value) => {
    state.accomodationUnitTypes = value.slice();
  },
};

export default {
    namespaced: true,
    state: () => state,
    getters,
    actions,
    mutations,
};